class SubmissionCreationException extends Error {
  constructor() {
    super('Error creating submission')

    this.name = 'SubmissionCreationException'
  }
}

export default SubmissionCreationException
